import gql from 'graphql-tag';

export const rejectProfilePictureMutation = gql`
  mutation rejectProfilePicture($approvalId: String!, $rejectionReason: String!) {
    rejectProfilePicture(approvalId: $approvalId, rejectionReason: $rejectionReason)
  }
`;
